/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { Coin } from "../../../cosmos/base/v1beta1/coin.js";
export const protobufPackage = "injective.erc20.v1beta1";
function createBaseParams() {
    return { denomCreationFee: undefined };
}
export const Params = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.denomCreationFee !== undefined) {
            Coin.encode(message.denomCreationFee, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denomCreationFee = Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { denomCreationFee: isSet(object.denomCreationFee) ? Coin.fromJSON(object.denomCreationFee) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.denomCreationFee !== undefined &&
            (obj.denomCreationFee = message.denomCreationFee ? Coin.toJSON(message.denomCreationFee) : undefined);
        return obj;
    },
    create(base) {
        return Params.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseParams();
        message.denomCreationFee = (object.denomCreationFee !== undefined && object.denomCreationFee !== null)
            ? Coin.fromPartial(object.denomCreationFee)
            : undefined;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
